import React, { useEffect, useState } from 'react';
import { db } from '../../firebase';
import { collection, getDocs } from 'firebase/firestore';
import * as XLSX from 'xlsx';
import './BookingDashboard.css';

const BookingDashboard = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const bookingsCollection = collection(db, 'Bookings');
        const bookingSnapshot = await getDocs(bookingsCollection);
        const bookingList = bookingSnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
        setBookings(bookingList);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching bookings:", error);
      }
    };
    fetchBookings();
  }, []);

  // Function to export data as Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(bookings);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Bookings");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "Bookings.xlsx");
  };

  return (
    <div className="bookingDashboard">
      <h1 className="dashboardTitle">Booking Dashboard</h1>
      
      {/* Button to download data as Excel */}
      <button className="downloadBtn" onClick={exportToExcel}>Download as Excel</button>

      {loading ? (
        <p>Loading bookings...</p>
      ) : (
        <table className="bookingTable">
          <thead>
            <tr>
              <th>Room Title</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Guests</th>
              <th>Children</th>
              <th>Booking Date</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map((booking) => (
              <tr key={booking.id}>
                <td>{booking.roomTitle}</td>
                <td>{booking.name}</td>
                <td>{booking.email}</td>
                <td>{booking.mobile}</td>
                <td>{booking.guests}</td>
                <td>{booking.children}</td>
                <td>{new Date(booking.timestamp.seconds * 1000).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BookingDashboard;
